(function () {
	'use strict';

	angular.module('app', ['ngSanitize', 'toastr']
	);

	angular.module('app').config(['toastrConfig', function(toastrConfig) {

        angular.extend(toastrConfig, {
            closeButton: true,
            positionClass: 'toast-top-right',
            closeHtml: '<a><i class="icon-om-open"></i></a>',
            iconClasses: {
                error: 'toast-error',
                info: 'toast-info',
                success: 'toast-success',
                warning: 'toast-warning'
            },
            timeOut: 5000
        });
    }]);
	
})();
